import { ApolloClient, ApolloProvider, InMemoryCache } from '@apollo/client'
import './App.css'
import Routing from './Routes'
import { BASE_URL } from './Services/constant'
import 'react-toastify/dist/ReactToastify.css'
import { ToastContainer } from 'react-toastify'
import AdminContext from './utils/context/TempAuth'

const client = new ApolloClient({
  uri: `${BASE_URL}/graphql`,
  cache: new InMemoryCache(),
})
function App() {
  return (
    <div className="App">
      <AdminContext>
        <ApolloProvider client={client}>
          <Routing />
          <ToastContainer
            position="top-right"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
        </ApolloProvider>
      </AdminContext>
    </div>
  )
}

export default App
